import ForgotPasswordBlock from './ForgotPasswordBlock';
import { ForgotPasswordBlockProps, ForgotPasswordBlockValueProps } from './types';

export type { ForgotPasswordBlockProps, ForgotPasswordBlockValueProps };
export default ForgotPasswordBlock;
